import { Reducer } from 'redux';
import {
    ToggleSnackBarPopupVisibilityAction,
    SnackBarPopupState,
    SnackBarPopupActions
} from './type';
import { TOGGLE_SNACKBAR_VISIBILITY } from './constants';
import { toggleSnackBarPopupVisibilityHandler } from './handlers';

export const initialState: SnackBarPopupState = {
    isVisible: false
};

const reducer: Reducer<SnackBarPopupState> = (state: SnackBarPopupState = initialState, action: SnackBarPopupActions) => {
    switch (action.type) {
        case TOGGLE_SNACKBAR_VISIBILITY :
            return toggleSnackBarPopupVisibilityHandler(state, action as ToggleSnackBarPopupVisibilityAction);

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/SnackBarPopup/reducer.ts